// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--1BHSa","svg":"Logo-module--svg--jsruo"};